module.exports = __webpack_public_path__ + "img/rotate-counter-clockwise.1427cf6a.svg";